import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "8",
      cy: "8",
      r: "8",
      fill: "#e84339"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#191715",
      d: "m10.573 5.01.148-2.136-4.146.395-.737 10.533 2.137-.204.331-4.729 1.906-.18.149-2.114-1.908.183.11-1.557z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "m10.276 4.685.148-2.135-4.146.395-.737 10.533 2.137-.204.331-4.729 1.906-.18.149-2.114-1.908.183.11-1.557z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "loyalty-f"}) } }